import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/PlayerList.css';

const TeamRoster = ({ playerData}) => {

  return (
    <div className="player-list-page">
      <div className="page-header">
        <h1>Team Roster</h1>
      </div>

      {playerData.length === 0 ? (
        <div className="no-results">Team has no players</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Player Name</th>
            </tr>
          </thead>
          <tbody>
            {playerData.map(player => (
              <tr
                key={player.id}
              >
                <td style={{ textAlign: 'center' }}>
                  <span className="player-username">{player.username}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TeamRoster;
